import React from "react";

export const options = {
  guide: {
    value: 0,
    label: "Guide",
  },
  manage: {
    value: 1,
    label: "Manage Sender IDs",
  },
};

export const email_sender_modals = {
  instructions: {
    value: 1,
  },
  add: {
    value: 2,
  },
  update: {
    value: 3,
  },
};

export const tableKeys = {
  name: "name",
  email: "email",
  status: "status",
};

export const statusCodes = {
  connect_gmail: 1,
  link_domain: 2,
  domain_link_in_progress: 3,
  sync_mail_records: 4,
  updating_mail_records: 5,
  sender_id_approved: 6,
  delink_existing_domain: 7,
  link_domain_failed: 8,
};

export const errorCodes = {
  domain_not_linked: 1,
  invalid_domain: 2,
  not_recommended: 3,
};

export const blockedDomains = ["gmail.com", "yahoo.com"];

export const initialValues = {
  name: "",
  email: "",
};

export const email_sender_overview = {
  title: "Overview",
  subTitle:
    "A sender ID is the name and email address that help recipients recognize your brand and feel confident opening your emails. To use a sender, it must be verified. For better email deliverability, your sender's domain should also be authenticated.",
};

export const email_sender_overview_points = [
  {
    title: "After integrating Email Sender IDs with your Exly, you can:",
    points: [
      <>Send Email from your own brand sender name and sender email.</>,
      <>
        Manage different sender IDs for different Email communications like
        broadcast, drips and automated communications.
      </>,
    ],
  },
];

export const email_sender_key_note = {
  title: "Key things to note..",
  points: [
    <>
      It is recommended to send from your own domain-based emails (not @gmail,
      @yahoo) to improve email deliverability and avoid failed emails!
    </>,
  ],
};

export const instructions = {
  title: "Follow the instructions below to add a new Email sender",
  points: [
    <>
      <span className="tw-font-[700]">Sender Name</span>: Specify what your
      recipients will see when they receive emails from this sender.
    </>,
    <>
      <span className="tw-font-[700]">From Email ID</span>: From email is the
      sender email address from which your recipients will receive your emails.
    </>,
  ],
  note: (
    <>
      <span className="tw-underline">Note</span>: Exly recommends using your
      domain-linked email ID for better deliverability. Format must be
      name@domain.com
    </>
  ),
  keyNote: email_sender_key_note,
};
